import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { AriaHidden } from "@swiggy-private/core-ui";
import { SpriteIconWeb } from "@swiggy-private/dls-web-icons/dist/SpriteIconWeb";

export const InstructionBoxContainer = styled.div<{ isSelected?: boolean; isPopCart?: boolean }>(
    ({ theme, isSelected, isPopCart }) => ({
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        height: "88px",
        width: "87px",
        padding: `10px ${theme.spacing.xSmall} ${theme.spacing.xSmall} 10px`,
        borderRadius: theme.cornerRadius.small,
        background: theme.colors[theme.colorMode].background_Primary,
        border: `1px solid ${theme.colors[theme.colorMode].border_Secondary}`,
        boxShadow: "none",

        ...(isSelected && {
            border: `1px solid ${
                isPopCart ? theme.colors[theme.colorMode].border_Primary : theme.colors[theme.colorMode].primary
            }`,
            background: isPopCart ? "#E6FFCE" : theme?.colors?.[theme?.colorMode]?.primary_Sub,
        }),
    }),
);

export const DisplayText = styled(Text)(({ theme }) => ({
    marginTop: theme.spacing.xxSmall,
    whiteSpace: "initial",
    textOverflow: "ellipsis",
}));

export const EditCrossIcon = styled(AriaHidden)(({ theme }) => ({
    position: "absolute",
    top: theme.spacing.small,
    right: theme.spacing.small,
}));

export const StyledVoiceIcon = styled(SpriteIconWeb)({
    marginLeft: "3px",
});

export const IconWrapper = styled(AriaHidden)({
    width: "26px",
    height: "31px",
});
